export class TranslateActionError {
  idTranslateActionError: number;
  idActionError: number;
  idLanguage: number;
  text: string;
  locked: boolean;

  constructor(
    idTranslateActionError: number,
    idActionError: number,
    idLanguage: number,
    text: string,
    locked: boolean,
  ) {
    this.idTranslateActionError = idTranslateActionError;
    this.idActionError = idActionError;
    this.idLanguage = idLanguage;
    this.text = text;
    this.locked = locked;
  }

  static fromRaw(raw: any): TranslateActionError {
    return new TranslateActionError(
      Number(raw.idTranslateActionError),
      Number(raw.idActionError),
      Number(raw.idLanguage),
      String(raw.text),
      Boolean(raw.locked),
    );
  }

  clone(): TranslateActionError {
    return new TranslateActionError(
      this.idTranslateActionError,
      this.idActionError,
      this.idLanguage,
      this.text,
      this.locked,
    );
  }

  toPayload(): any {
    const payload: any = {
      idActionError: this.idActionError,
      idLanguage: this.idLanguage,
      text: this.text,
    };
    if (this.idTranslateActionError !== 0) {
      payload.idTranslateActionError = this.idTranslateActionError;
    }
    return payload;
  }
}
